import React from 'react'
import PropTypes from 'prop-types'
import LargePageSearch from '../home-page/large-page-search.jsx'
import SmallPageSearch from '../home-page/small-page-search.jsx'
import MobileSearchBox from '../mobile-search-box.jsx/mobile-search-box.jsx'
import utils from '../../lib/utils'
import moment from 'moment'
import { convertDataToRoomQuery } from "../../services/utils";

const defaultRoomData = {
  room: 1,
  nr_adults: 2,
  children: []
}

class FullSearchBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: this.props.state.userId ? this.props.state.userId : undefined,
      location:  undefined,
      mobilityClass:  undefined,
      startDate:  moment(new Date()),
      endDate:  undefined,
      //nrGuests: 2,
      roomsData: [defaultRoomData],
    }

    this.onChangeMobilityIcon = this.onChangeMobilityIcon.bind(this)
    this.onReceivedSearchResults = this.onReceivedSearchResults.bind(this)
    this.onMobilityClassChange = this.onMobilityClassChange.bind(this)
    this.onSearchQueryChange = this.onSearchQueryChange.bind(this)
    this.onDatesChange = this.onDatesChange.bind(this)
    this.onSearchClick = this.onSearchClick.bind(this)
    // this.onChangeNrGuests = this.onChangeNrGuests.bind(this)
    this.onChangeRoomsData = this.onChangeRoomsData.bind(this)
  }

  onSearchClick () {
    window.coordsFixed = false
    if (this.state.location) {
      let zoomLevel = '&z=10'
      let path = `/${this.props.state.locale}/search/?q=${encodeURIComponent(this.state.location)}&mobility_class_old=${this.state.mobilityClass}`
      // if (this.state.nrGuests !== 1) {
      //   path += `&nr_guests=${this.state.nrGuests}`
      // }
      if (this.state.startDate && this.state.endDate) {
        path += `&start_date=${utils.getDateString(this.state.startDate)}&end_date=${utils.getDateString(this.state.endDate)}`
      }
      switch (this.state.type) {
      case 'locality':
        zoomLevel = '&z=13'
        break
      case 'country':
        zoomLevel = '&z=8'
        break
      case 'administrative_area_level_2':
        zoomLevel = '&z=8'
        break
      case 'administrative_area_level_1':
        zoomLevel = '&z=8'
        break
      case 'neighborhood':
        zoomLevel = '&z=13'
        break  
      case 'establishment':
        zoomLevel = '&z=10'
        break
      }
      switch(this.state.location){
      case 'Malta': 
      case 'Isle of Wight':
      case 'Isle of Sheppey':
      case 'Hayling Island':
      case 'Foulness Island':
      case 'Portsea Island':
      case 'Canvey Island':
      case 'Mersea Island':
      case 'Walney Island':
      case 'Wallasea Island':
      case 'Lundy':
      case 'Isles of Scilly':
      case 'Shetland':
      case 'Orkney':
      case 'Outer Hebrides':
      case 'Inner Hebrides':
      case 'Islands of the Clyde':
      case 'Islands of the Forth':
      case 'Outlying islands':
      case 'Lewis and Harris':
      case 'Skye':
      case 'Mainland, Shetland':
      case 'Mull':
      case 'Islay':
      case 'Mainland, Orkney':
      case 'Arran':
      case 'Jura':
      case 'South Uist':
      case 'North Uist':
      case 'Anglesey':
      case 'Holy Island':
      case 'Skomer':
      case 'Ramsey Island':
      case 'Caldey Island':
      case 'Achill Island':
      case 'Aran Islands':
      case 'Rathlin Island':
      case 'Jersey':
      case 'Guernsey':
      case 'Alderney':
      case 'Isle of Man':
      case 'Bornholm':
      case 'Falster':
      case 'Funen':
      case 'Lolland':
      case 'Zealand':
      case 'Abruka':
      case 'Hiiumaa':
      case 'Kihnu':
      case 'Muhumaa':
      case 'Naissaar':
      case 'Osmussaar':
      case 'Piirissaar':
      case 'Ruhnu':
      case 'Saaremaa':
      case 'Vilsandi':
      case 'Vormsi':
      case 'Gotland':
      case 'Öland':
      case 'Orust':
      case 'Hisingen':
      case 'Värmdö':
      case 'Tjörn':
      case 'Åland Islands':
      case 'Fehmarn': 
      case 'Hailuoto': 
      case 'Rügen':
      case 'Usedom/Uznam':
      case 'Wolin': 
      case 'Azores': 
      case 'Madeira': 
      case 'Canary Islands':
      case 'Faroe Islands':
      case 'Frisian Islands':
      case 'Danish Wadden Sea Islands':
      case 'North Jutlandic Island':
      case 'Balearic Islands':
      case 'Comino':
      case 'Cominotto': 
      case 'Corsica': 
      case 'Elba': 
      case 'Fungus Rock':
      case 'Gozo': 
      case 'Filfla': 
      case 'Ischia': 
      case 'Lampedusa':  
      case 'Manoel Island':
      case 'Pantelleria': 
      case 'Ponza': 
      case 'Sardinia': 
      case 'Sicily': 
      case 'St. Paul\'s Islands':
      case 'Crete':
      case 'Euboea':
      case 'Lesbos Island':
      case 'Rhodes': 
      case 'Chios':
      case 'Cyclades':
      case 'Dodecanese':
      case 'Sporades':
      case 'Northeastern Aegean Islands':
      case 'Argo-Saronic Islands':
      case 'Ionian Islands':
      case 'Sveti Nikola Island':
      case 'Krk':
      case 'Rab':
      case 'Cres':
      case 'Pag':
      case 'Hvar':
      case 'Dugi Otok':
      case 'Mljet':
      case 'Brač':
      case 'Korčula':
      case 'Lošinj':
      case 'Šolta':
      case 'Ugljan':
      case 'Lastovo':
      case 'Čiovo':
      case 'Molat':
      case 'Vir':
      case 'Cyprus':
      case 'Andorra':
        zoomLevel = '&z=11'
        break
      }
      path+= zoomLevel
      const roomsQuery = convertDataToRoomQuery(this.state.roomsData);
      path += roomsQuery
      this.props.router.push(path)
    }
  }

  onReceivedSearchResults (searchQuery, features){
    if (features && features.length > 0) {
      const feature = features[0]
      this.setState({type: feature.properties.types[0]})
    }
  }

  // onChangeNrGuests (nrGuests) {
  //   this.setState({nrGuests})
  // }

  onChangeRoomsData (roomsData) {
    this.setState({roomsData})
  }

  onMobilityClassChange (mobilityClass) {
    this.setState({mobilityClass})
  }

  onSearchQueryChange (location) {
    this.setState({location})
  }
  onChangeMobilityIcon(mobilityClass) {
    this.setState({mobilityClass})
  }

  onDatesChange( {startDate, endDate} ){
    this.setState({startDate, endDate})
  }

  render() {
    let searchProps = Object.assign({}, this.props, {
      onReceivedSearchResults: this.onReceivedSearchResults,
      onMobilityClassChange: this.onMobilityClassChange,
      onSearchQueryChange: this.onSearchQueryChange,
      searchQuery: this.state.location,
      mobilityClass: this.state.mobilityClass,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      onDatesChange: this.onDatesChange,
      onSearchClick: this.onSearchClick,
      // onChangeNrGuests: this.onChangeNrGuests,
      // nrGuests: this.state.nrGuests,
      datesPreOpen: this.props.datesPreOpen,
      roomsData: this.state.roomsData,
      onChangeRoomsData: this.onChangeRoomsData,
    })

    this.state.startDate ? searchProps.startDate = this.state.startDate : null
    this.state.endDate ? searchProps.endDate = this.state.endDate : null
    if(moment(this.state.startDate).isBefore(new Date())){
      searchProps.startDate = moment(new Date())
    }
    if(moment(this.state.endDate).isBefore(new Date())){
      searchProps.endDate = moment(new Date()).add(1,'days')
    }
    let deviceSize = this.props.state.noStore.deviceSize
    let searchBar = null
    if(deviceSize === 'xs' || deviceSize === 'sm'){
      searchBar = (<></>
        // <MobileSearchBox {...searchProps} />
      )
    } else {
      searchBar = (<></>
        // <div className='search-wrapper'>
        //   <LargePageSearch {...searchProps} />
        // </div>
      )
    }
    return (
      <div>
        {searchBar}
      </div>
    )}
}

FullSearchBar.propTypes = {
  router: PropTypes.object,
  onSearchInputReady: PropTypes.func,
  onReceivedSearchResults: PropTypes.func,
  onSearchInputChange: PropTypes.func,
  onChangeMobilityIcon: PropTypes.func,
  onDatesChange: PropTypes.func,
  onSearchClicked: PropTypes.func,
  state: PropTypes.object,
}

export default FullSearchBar